export default __webpack_public_path__ + "static/media/ena.e350bc11.png";